// 中央 API 请求封装 + 鉴权 token 管理。
// 后端契约见 ../DESIGN.md、../docs/PROJECT.md。JWT 存于 localStorage，通过 Authorization: Bearer 携带。

const BASE = '/api';

export function getToken() {
  return localStorage.getItem('token');
}
export function setToken(token) {
  localStorage.setItem('token', token);
}
export function clearToken() {
  localStorage.removeItem('token');
}

// 统一请求：失败时抛出 Error，附带 status 与解析后的响应体（供调用方读取 requireCaptcha 等字段）。
export async function api(path, { method = 'GET', body, auth = false, form = false, signal } = {}) {
  const headers = {};
  if (auth) {
    const token = getToken();
    if (token) headers['Authorization'] = 'Bearer ' + token;
  }
  const opts = { method, headers, signal };
  if (body !== undefined) {
    if (form) {
      opts.body = body; // FormData（文件上传），不要手动设置 Content-Type
    } else {
      headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
  }

  let res;
  try {
    res = await fetch(BASE + path, opts);
  } catch (e) {
    const err = new Error('网络错误，无法连接到服务器');
    err.code = 'NETWORK';
    throw err;
  }

  // 鉴权失效：清 token 并跳登录（pathname 路由；basename 取自 Vite base）
  if (res.status === 401 && auth) {
    clearToken();
    const base = import.meta.env.BASE_URL.replace(/\/$/, '');
    if (location.pathname !== base + '/login') location.href = base + '/login';
  }

  const ct = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json() : await res.text();

  if (!res.ok) {
    const err = new Error((data && data.error) || '服务器错误');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// ---- 具体接口 ----
export const apiSearch = (q) => api('/search' + (q ? '?q=' + encodeURIComponent(q) : ''));

export const apiCaptcha = () => api('/captcha');

export const apiLogin = (body) => api('/login', { method: 'POST', body });

export const apiChangePassword = (body) =>
  api('/change-password', { method: 'POST', body, auth: true });

export const apiRecords = (params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''))
  ).toString();
  return api('/admin/records' + (qs ? '?' + qs : ''), { auth: true });
};

export const apiCreateRecord = (body) =>
  api('/admin/records', { method: 'POST', body, auth: true });

export const apiUpdateRecord = (id, body) =>
  api('/admin/records/' + encodeURIComponent(id), { method: 'PUT', body, auth: true });

export const apiDeleteRecord = (id) =>
  api('/admin/records/' + encodeURIComponent(id), { method: 'DELETE', auth: true });

export const apiUploadImage = (formData) =>
  api('/upload', { method: 'POST', body: formData, form: true, auth: true });

export const apiDeleteImage = (imageUrl) =>
  api('/upload/delete', { method: 'POST', body: { imageUrl }, auth: true });
